import React, { useState } from 'react';
import styles from './MediaViewport.module.css';

const MediaViewport = ({ src, alt, description, bullets = [] }) => {
  const [zoom, setZoom] = useState(1);
  const changeZoom = (delta) => setZoom(value => Math.min(4, Math.max(1, value + delta)));

  return (
    <>
      <div className={styles.toolbar} role="group" aria-label="Image viewing controls">
        <button type="button" onClick={() => setZoom(1)} aria-pressed={zoom === 1}>Fit</button>
        <button type="button" onClick={() => changeZoom(-0.5)} disabled={zoom <= 1} aria-label="Zoom out">−</button>
        <span aria-live="polite">{zoom}×</span>
        <button type="button" onClick={() => changeZoom(0.5)} disabled={zoom >= 4} aria-label="Zoom in">+</button>
        <a href={src} target="_blank" rel="noopener noreferrer">Open full image ↗</a>
      </div>
      <div className={styles.viewport} tabIndex={0} aria-label="Scrollable image viewport; use the zoom controls to inspect details">
        <img src={src} alt={alt} className={styles.image} style={{ width: `${zoom * 100}%` }} />
      </div>
      <div className={styles.description}>
        <p>{description}</p>
        {bullets.length > 0 && <ul>{bullets.map(item => <li key={item}>{item}</li>)}</ul>}
      </div>
    </>
  );
};

export default MediaViewport;
